import { useEffect, useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { API } from "@/config";

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—");

export const AttendanceSection = () => {
  const [records, setRecords] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [date, setDate] = useState("");
  const [employeeId, setEmployeeId] = useState("all");

  const fetchData = async () => {
    const params = {};
    if (date) params.date = date;
    if (employeeId !== "all") params.employee_id = employeeId;
    const { data } = await axios.get(`${API}/attendance`, { params, withCredentials: true });
    setRecords(data);
  };

  useEffect(() => {
    axios.get(`${API}/employees`, { withCredentials: true }).then((r) => setEmployees(r.data));
  }, []);

  useEffect(() => {
    fetchData();
  }, [date, employeeId]);

  return (
    <div data-testid="attendance-section">
      <div className="flex flex-wrap gap-3">
        <Input type="date" className="w-44" value={date} onChange={(e) => setDate(e.target.value)} data-testid="attendance-date-filter" />
        <Select value={employeeId} onValueChange={setEmployeeId}>
          <SelectTrigger className="w-52" data-testid="attendance-employee-filter">
            <SelectValue placeholder="All employees" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All employees</SelectItem>
            {employees.map((e) => (
              <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-border bg-card shadow-sm">
        <Table data-testid="attendance-table">
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Employee</TableHead>
              <TableHead>Check In</TableHead>
              <TableHead>Check Out</TableHead>
              <TableHead>Hours</TableHead>
              <TableHead>Overtime</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {records.map((r) => (
              <TableRow key={r.id} data-testid={`attendance-row-${r.id}`}>
                <TableCell>{r.date}</TableCell>
                <TableCell className="font-medium">{r.employee_name}</TableCell>
                <TableCell>{fmtTime(r.check_in)}</TableCell>
                <TableCell>{fmtTime(r.check_out)}</TableCell>
                <TableCell>{r.hours}</TableCell>
                <TableCell>{r.overtime_hours}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {records.length === 0 && (
          <p className="p-8 text-center text-sm text-muted-foreground">No attendance records.</p>
        )}
      </div>
    </div>
  );
};
